// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { productPartNumbersStyles } from "@vanmeter/Overrides/Components/ProductPartNumbers";
import { fontConfig } from "@vanmeter/XDL/constants";
import { hideEmpty } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

export const partNumbersStyle: { label?: TypographyProps; value?: TypographyProps } = {
    label: {
        ...fontConfig.xSmallSingleLine,
        weight: fontConfig.weight.bold,
        css: css`
            flex: 0 0 auto;
            letter-spacing: 0;
            margin-right: 4px;
            padding-left: 0;
            &:after {
                content: ":";
            }
        `,
    },
    value: {
        ...fontConfig.xSmallSingleLine,
        css: css`
            flex: 1 1 auto;
            letter-spacing: 0;
            min-width: 0;
            ${wrapInContainerStyles}
        `,
    },
};

productPartNumbersStyles.container = { gap: 0 };

productPartNumbersStyles.erpNumberLabelText =
    productPartNumbersStyles.customerNameLabelText =
    productPartNumbersStyles.manufacturerItemLabelText =
        {
            ...partNumbersStyle.label,
        };

productPartNumbersStyles.erpNumberValueText =
    productPartNumbersStyles.customerNameValueText =
    productPartNumbersStyles.manufacturerItemValueText =
        {
            ...partNumbersStyle.value,
        };

productPartNumbersStyles.customerNameGridItem = {
    width: 12,
    css: css`
        display: flex;
        ${hideEmpty}
    `,
};

productPartNumbersStyles.cpnValueWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
